import { User } from './user'
import { SentEmail } from './sentEmail'

export class ClientMessage {
  createdAt: Date
  content: string
  recipient: User
}

export class SmsClientMessage implements ClientMessage {
  createdAt: Date
  content: string
  recipient: User
  phoneNumber: number
}

export class EmailClientMessage implements ClientMessage {
  createdAt: Date
  content: string
  recipient: User
  toEmail: string

  static createFromSentEmail(sentEmail: SentEmail, users: User[]): EmailClientMessage {
    const m = new EmailClientMessage()
    m.createdAt = sentEmail.createdAt
    m.content = sentEmail.body
    m.toEmail = sentEmail.to
    m.recipient = User.findByEmail(users, sentEmail.to)

    return m
  }
}
